import {Flex, Input, Select, theme, Typography} from 'antd';
import React from 'react';
import {getSearchLabelStyle} from 'Components/CustomTextInput/labelStyles';

const {Text} = Typography;

// Scoped to Pages/SearchMember — a small antd label+input/select field, standing
// in for the shared (MUI-based) Components/CustomTextInput on this page only.
// formik.handleChange only needs `e.target.{name,value}`, so antd's Select
// (which reports a raw value, not an event) is bridged into that same shape.
interface AntSearchFieldProps {
  label: string;
  name: string;
  value?: string;
  onChange: (e: {target: {name: string; value: string}}) => void;
  disabled?: boolean;
  options?: string[];
}

const AntSearchField: React.FC<AntSearchFieldProps> = ({
  label,
  name,
  value,
  onChange,
  disabled,
  options,
}) => {
  const {token} = theme.useToken();
  return (
    <Flex vertical gap={6} style={{flex: 1, minWidth: 0}}>
      <Text style={getSearchLabelStyle(token, disabled)}>{label}</Text>
      {options ? (
        <Select
          value={value || undefined}
          disabled={disabled}
          // Client must always hold a value — clearing it crashes setTenantDetails.
          allowClear={name !== 'client'}
          onChange={(val) => onChange({target: {name, value: val ?? ''}})}
          options={options.map((option) => ({label: option, value: option}))}
        />
      ) : (
        <Input
          // Phone Number was numeric-only in the old shared input; keep that.
          type={name === 'phoneNumber' ? 'number' : 'text'}
          name={name}
          value={value || ''}
          disabled={disabled}
          onChange={onChange}
        />
      )}
    </Flex>
  );
};

export default AntSearchField;
